module.exports = {
  name: 'GatewayDetail',
  props: ['uid', 'mac', 'data', 'compact', 'optionCommands', 'itemCommands'],
  components: {
    'gateway-header': require('./GatewayHeaderItem'),
    'gateway-large-items': require('./GatewayLargeItems'),
    'gateway-small-items': require('./GatewaySmallItems')
  },
  computed: {
    isDisconnected() {
      let now = new Date().getTime();
      let diff = now - this.data.updatedTime;
      return (diff > 10 * 60 * 1000);
    }
  },
  methods: {
    popup(val) {
      this.$emit('popup', val);
    }
  },
  template: `
<v-card>
  <gateway-header :uid="uid" :mac="mac" :data="data" :isDisconnected="isDisconnected" :optionCommands="optionCommands" @popup="popup">
    <slot name="disconnected" v-if="isDisconnected"></slot>
    <slot v-else></slot>
  </gateway-header>
  <v-divider></v-divider>
  <gateway-small-items v-if="compact" :uid="uid" :mac="mac" :data="data" :isDisconnected="isDisconnected" :commands="itemCommands"></gateway-small-items>
  <gateway-large-items v-else :uid="uid" :mac="mac" :data="data" :isDisconnected="isDisconnected" :commands="itemCommands" @popup="popup"></gateway-large-items>
</v-card>
  `
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/luffanet-web-components/GatewayItem.js
// module id = OJCB
// module chunks = 0